import * as Yup from 'yup';

export const definedStringSchema = Yup.string().defined().strict(true);

export const translatableFieldSchema = Yup.object({
  es_ES: Yup.string().nullable(),
  en_GB: Yup.string().nullable()
}).nonNullable();

export const selectValueSchema = Yup.object().shape({
  value: definedStringSchema,
  label: definedStringSchema
});

export const patientTeaserSchema = Yup.object()
  .shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
    surname: Yup.string().required(),
    fullname: Yup.string().required(),
    email: Yup.string().nullable().default(null),
    image: Yup.string().nullable().default(null),
    imageThumbnail: Yup.string().nullable().default(null),
    isReferred: Yup.bool().required(),
    nhc: Yup.string().nullable().default(null),
    isEnabled: Yup.bool().required(),
    lastLogin: Yup.string().required(),
    idCard: Yup.string().nullable().default(null),
    birthDate: Yup.string().nullable().default(null),
    telephone: Yup.string().nullable().default(null),
    studyTerminatedAt: Yup.string().nullable().default(null),
    studyTerminatedBy: Yup.string().nullable().default(null)
  })
  .nullable()
  .notOneOf([null], 'ui:form.errors.required');
